import { render, staticRenderFns } from "./SolicitudDadoDeBaja.vue?vue&type=template&id=1a3e7252"
import script from "./SolicitudDadoDeBaja.vue?vue&type=script&lang=js"
export * from "./SolicitudDadoDeBaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports